export const hcoSearchItemInputStyles = {
	profileCard: {
		name: {
			fontWeight: 700
		}
	}
};
